// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1834":"41e3496a","7066":"41e3496a","9646":"41e3496a"}[chunkId] + ".chunk.css";
};